import { FEATURES } from "@proj-common/const"
import { planFeatureAvailability, planFeatureID } from "@proj-common/enums"
import { IPlan } from "@proj-common/types"

export const ProfessionalPlan: IPlan = {
    paddleProductData: {
        name: "Professional",
        taxCategory: "saas",
        customData: {
            lookup_key: "professional",
            type: "plan",
            order: "2",
        },
        type: "standard",
    },
    paddlePriceData: [
        {
            //productId: null, // need to change to actual product ID after creation
            description: "Professional Monthly",
            name: "Professional Monthly",
            unitPrice: {
                amount: "5000",
                currencyCode: "USD"
            },
            billingCycle: {
                frequency: 1,
                interval: "month",
            },
            quantity: {
                maximum: 1,
                minimum: 1,
            },
            taxMode: "external",
            // trialPeriod: {
            //     frequency: 30,
            //     interval: "day",
            // },
            customData: {
                lookup_key: "professional_monthly",
            },
            type: "standard",
        },
        {
            //productId: null, // need to change to actual product ID after creation
            description: "Professional Monthly with trial",
            name: "Professional Monthly",
            unitPrice: {
                amount: "5000",
                currencyCode: "USD"
            },
            billingCycle: {
                frequency: 1,
                interval: "month",
            },
            quantity: {
                maximum: 1,
                minimum: 1,
            },
            taxMode: "external",
            trialPeriod: {
                frequency: 30,
                interval: "day",
            },
            customData: {
                lookup_key: "professional_monthly_trial",
            },
            type: "standard",
        },
        {
            //productId: null, // need to change to actual product ID after creation
            description: "Professional Yearly",
            name: "Professional Yearly",
            unitPrice: {
                amount: "48000",
                currencyCode: "USD"
            },
            billingCycle: {
                frequency: 1,
                interval: "year",
            },
            quantity: {
                maximum: 1,
                minimum: 1,
            },
            taxMode: "external",
            // trialPeriod: {
            //     frequency: 30,
            //     interval: "day",
            // },
            customData: {
                lookup_key: "professional_yearly",
            },
            type: "standard",
        },
        {
            //productId: null, // need to change to actual product ID after creation
            description: "Professional Yearly with trial",
            name: "Professional Yearly",
            unitPrice: {
                amount: "48000",
                currencyCode: "USD"
            },
            billingCycle: {
                frequency: 1,
                interval: "year",
            },
            quantity: {
                maximum: 1,
                minimum: 1,
            },
            taxMode: "external",
            trialPeriod: {
                frequency: 30,
                interval: "day",
            },
            customData: {
                lookup_key: "professional_yearly_trial",
            },
            type: "standard",
        },
    ],
    paddleAddonPriceData: [
        {
            //productId: addonsProduct.id,
            description: "Enable Powerpoint Reporting",
            name: "Enable Powerpoint Reporting",
            unitPrice: {
                amount: "800",
                currencyCode: "USD"
            },
            billingCycle: null,
            quantity: {
                maximum: 1,
                minimum: 1,
            },
            taxMode: "external",
            customData: {
                lookup_key: "professional_addon_ppt_reporting",
            },
            type: "standard",
        }
    ],
    details: {
        small_text: "For professionals running frequent sessions with automatic reporting, multiple export formats and real-time facilitation tools.",
        CTA_text: "Try for free",
        featured: true,
    },
    features: [
        {
            id: FEATURES.sessions_per_month.id,
            availability: planFeatureAvailability.included,
            description: FEATURES.sessions_per_month.description,
            label: FEATURES.sessions_per_month.label,
            value: 10,
        },
        {
            id: FEATURES.max_participants_per_session.id,
            availability: planFeatureAvailability.included,
            description: FEATURES.max_participants_per_session.description,
            label: FEATURES.max_participants_per_session.label,
            value: 30,
        },
        {
            id: FEATURES.export_basic.id,
            availability: planFeatureAvailability.included,
            description: FEATURES.export_basic.description,
            label: FEATURES.export_basic.label,
        },
        {
            id: FEATURES.export_apps.id,
            availability: planFeatureAvailability.included,
            description: FEATURES.export_apps.description,
            label: FEATURES.export_apps.label,
        },
        {
            id: FEATURES.reporting_html.id,
            availability: planFeatureAvailability.included,
            description: FEATURES.reporting_html.description,
            label: FEATURES.reporting_html.label,
        },
        {
            id: FEATURES.reporting_powerpoint.id,
            availability: planFeatureAvailability.optional,
            description: FEATURES.reporting_powerpoint.description,
            label: FEATURES.reporting_powerpoint.label,
            lookup_key: "professional_addon_ppt_reporting",
        },
        {
            id: FEATURES.ai_ideas_grouping.id,
            availability: planFeatureAvailability.included,
            description: FEATURES.ai_ideas_grouping.description,
            label: FEATURES.ai_ideas_grouping.label,
        },
        {
            id: FEATURES.ai_custom_participants.id,
            availability: planFeatureAvailability.included,
            description: FEATURES.ai_custom_participants.description,
            label: FEATURES.ai_custom_participants.label,
        },
    ]
}